export const imageContainer = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  zIndex: 100,
  position: "relative",
};

export const paginationDots = {
  position: "absolute",
  bottom: "40px",
  left: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  gap: "10px",
};

export const paginationDot = ({
  isSelected,
  paginationDotsColor,
  backgroundColor,
}) => ({
  width: "20px",
  height: "20px",
  border: "2px solid",
  borderColor: paginationDotsColor,
  borderRadius: "50%",
  backgroundColor: isSelected ? paginationDotsColor : backgroundColor,
});

export const carouselScrollContainer =
  ({ disableScroll }) =>
  ({ isDesktop }) => ({
    overflowX: disableScroll ? "hidden" : "auto",
    scrollSnapType: "x mandatory",
    scrollBehavior: "smooth",
    height: "545px",
    borderRadius: isDesktop ? "0 10px 10px 0" : "0 0 10px 10px",
  });

export const carouselMedia = {
  height: "100%",
  display: "flex",
};

export const carouselItem = ({ backgroundColor = "none" }) => ({
  backgroundColor: backgroundColor,
  width: "100%",
  flexShrink: "0",
  scrollSnapAlign: "center",

  "&:first-of-type": {
    scrollSnapAlign: "start",
  },

  "&:last-of-type": {
    scrollSnapAlign: "end",
  },

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  overflow: "hidden",
});

export const displayImage = {
  display: "block",
  objectFit: "cover",
  width: "100%",
  height: "100%",
  objectPosition: "center",
};

export const imageTitle = ({ textColor = "black" }) => ({
  fontFamily: "dinCondensed",
  fontWeight: "300",
  color: textColor,
  mt: "40px",
  position: "absolute",
  top: 0,
});
